import React, { useState } from "react";
import { QrCodeImage } from "./qr-code-image";
import { downloadQrCodesPdf, openQrCodesPdf } from "../helpers/generate-qr-codes-pdf";

interface IProps {
  codes: string[];
}

export const QrCodesSheet: React.FC<IProps> = ({ codes }) => {
  const [generating, setGenerating] = useState<"view" | "download" | null>(null);

  if (!codes.length) return null;

  const handleView = async () => {
    setGenerating("view");
    try {
      await openQrCodesPdf(codes);
    } finally {
      setGenerating(null);
    }
  };

  const handleDownload = async () => {
    setGenerating("download");
    try {
      await downloadQrCodesPdf(codes);
    } finally {
      setGenerating(null);
    }
  };

  return (
    <div>
      <div className="flex justify-end gap-2 mb-3">
        <button
          className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          onClick={handleView}
          disabled={generating !== null}
        >
          {generating === "view" ? "Génération..." : "Visualiser"}
        </button>
        <button
          className="btn"
          onClick={handleDownload}
          disabled={generating !== null}
        >
          {generating === "download" ? "Génération..." : "Télécharger"}
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {codes.map((code) => (
          <div
            key={code}
            className="flex flex-col items-center gap-2 border border-gray-200 rounded p-3"
          >
            <QrCodeImage value={code} size={120} />
            <p className="text-xs text-gray-500 break-all text-center">{code}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
